import classNames from "classnames";

import Img from "@components/FileServer/Img";

type Props = {
  onMinusSign: (type: string) => void;
  onPlusSign: (type: string) => void;
  value: number;
  type?: string;
  disabledPlus?: boolean;
  disabledMinus?: boolean;
};

const Counter = ({
  onMinusSign,
  onPlusSign,
  value,
  type,
  disabledMinus,
  disabledPlus,
}: Props) => {
  const counterSignMinusClass = classNames("counter-sign", {
    "counter-sign-disabled": disabledMinus === true,
  });

  const counterSignPlusClass = classNames("counter-sign", {
    "counter-sign-disabled": disabledPlus === true,
  });
  const counterType = type || "";

  return (
    <div className="counter-container">
      <button
        className={counterSignMinusClass}
        disabled={disabledMinus}
        id={`properties_counter_${type}_minus`}
        onClick={() => onMinusSign(counterType)}
        type="button"
        aria-label={`Decrease ${counterType}`}
      >
        <Img src="/static/images/ico-minus.svg" alt="" />
      </button>
      <span id={`properties_counter_${type}_value`}>{value}</span>
      <button
        className={counterSignPlusClass}
        disabled={disabledPlus}
        id={`properties_counter_${type}_plus`}
        onClick={() => onPlusSign(counterType)}
        type="button"
        aria-label={`Increase ${counterType}`}
      >
        <Img src="/static/images/ico-plus.svg" alt="" />
      </button>
    </div>
  );
};

export default Counter;
